export default __webpack_public_path__ + "static/media/B.9b5ee64f.png";